import React, { PropsWithChildren } from 'react';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { AssetImage } from '@ff-os/shared-react/components/asset-image/AssetImage';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import styles from './ChangeVariantWindow.module.scss';

export const ChangeVariantWindowStep = ({ className, children, imageUrl, stepper: Stepper }: Props) => {
    const isMobile = useMobile();
    return (
        <>
            {Stepper && isMobile && (
                <div className={styles.stepper}>
                    <Stepper />
                </div>
            )}

            <div className={className}>
                {imageUrl && (
                    <div className={styles.photoContainer}>
                        <AspectRatio>
                            <AssetImage className={styles.photo} src={imageUrl} />
                        </AspectRatio>
                    </div>
                )}

                <div className={styles.scroll}>
                    {children}
                </div>
            </div>
        </>
    );
};

type Props = PropsWithChildren<{
    stepper?: () => JSX.Element;
    className?: string;
    imageUrl?: string;
}>;